var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_312_461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3418 0H2.65968C1.19088 0 0 1.15488 0 2.57904V33.4195C0 34.8451 1.19088 36 2.65968 36H33.3418C34.8106 36 36 34.8437 36 33.4195V2.57904C36 1.15488 34.8106 0 33.3418 0Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3087 10.0073L25.8759 26.1963C25.6167 27.3387 24.9415 27.6231 23.982 27.0852L18.7511 23.2307L16.2275 25.6585C15.948 25.938 15.7148 26.1712 15.1761 26.1712L15.5523 20.8444L25.2462 12.0848C25.6679 11.7095 25.1544 11.5007 24.5914 11.8768L12.607 19.4233L7.44761 17.8081C6.32554 17.4579 6.30523 16.686 7.68161 16.1473L27.8617 8.37253C28.796 8.02234 29.6134 8.57972 29.3087 10.0073Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_312_461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e9dcd6aeb331f8d2e8ff52250e7b5879.svg";
export { ForwardRef as ReactComponent };